import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import ProcessingSpinner from '../../ProcessingSpinner';

const SettingsEditButtons = ({ saving, handleSave, unsaved }) => {
  const intl = useIntl();

  return (
    <div className={classnames('justify-sb settings-save-wrapper', { 'settings-save-wrapper-unsaved': unsaved })}>
      <div className="buttons-group" />
      <div className="buttons-group">
        {unsaved && (
          <p>
            {intl.formatMessage({ defaultMessage: 'You have some unsaved settings' })}
          </p>
        )}
        <Button
          color="primary"
          disabled={saving}
          onClick={handleSave}
        >
          <ProcessingSpinner show={saving} />
          {intl.formatMessage({ defaultMessage: 'Save' })}
        </Button>
      </div>
    </div>
  );
};

SettingsEditButtons.propTypes = {
  unsaved: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default SettingsEditButtons;
